const apiurl = localStorage.getItem('apiurl');

export default apiurl